/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {PhoneNumberInput} from "./phoneNumberInput.zod";

export const ContactInputFields = zod.object({
  name: zod.string(),
  description: zod.string().optional(),
  email: zod.email().optional(),
  phone: PhoneNumberInput.optional(),
});

export type ContactInputFields = zod.input<typeof ContactInputFields>;
export type ContactInputFieldsOutput = zod.output<typeof ContactInputFields>;
